import React from "react";
import * as yup from "yup";
import { DrawerFormSaveResult, hasClientErrorOperationStatusCode } from "../../../assets/utils/lib";

import Drawer from "../../../assets/vfx/drawer/drawer";
import Form from "../../../assets/vfx/form/form";
import { StringHelper } from "../../../assets/utils/helpers";
import { Constants } from "../../../assets/utils/lib/constants";
import { SubscriptionDto } from "../../../services/dto";

interface SubscriptionFormProps {
  loading?: boolean;
  data?: SubscriptionDto;
  show: boolean;
  onHide: () => void;
  onSave: (values: SubscriptionDto) => DrawerFormSaveResult;
}

const validationSchema = yup.object().shape({
  name: yup.string().required("Name is required."),
  description: yup.string().optional(),
  activationDate: yup
    .date()
    .typeError("Please enter a valid date.")
    .nullable()
    .required("Activation date is required."),
});

const getTitle = (id: string | undefined): string =>
  StringHelper.whenNullOrEmpty(id, Constants.emptyGuid) === Constants.emptyGuid
    ? "New Subscription"
    : "Edit Subscription";

export const SubscriptionForm = (props: SubscriptionFormProps) => {
  const title: string = getTitle(props.data?.id);

  const handleSubmit = (formData: SubscriptionDto) => {
    return Promise.resolve(props.onSave(formData)).then((result) => {
        if (hasClientErrorOperationStatusCode(result)) {
            return;
        }

        props.onHide();
    });
  };

  return (
    <Drawer.Form
      className="w-30"
      show={props.show}
      backdrop
      placement="end"
      scroll
      enableReinitialize
      title={title}
      initialValues={props.data ?? {}}
      validationSchema={validationSchema}
      onHide={props.onHide}
      on_Submit={handleSubmit}
    >
      <Form.Text
        name="name"
        label="Name"
        placeholder="Enter text"
        isLoading={props.loading}
      />

      <Form.TextArea
        name="description"
        label="Description"
        rows={3}
        isLoading={props.loading}
      />

      <Form.Date
        name="activationDate"
        label="Activation Date"
        placeholder="Enter date"
        isLoading={props.loading}
      />
    </Drawer.Form>
  );
};
